var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters"},[_vm._l((_vm.filters),function({
      type: filterType,
      name,
      col,
      label,
      placeholder,
      items,
      options,
      optionLabel,
      keyValue,
      min,
      max,
      postfix,
      isTall,
    }){return [(_vm.checkFilterAvailability({ type: filterType, options }))?_c(_vm.getComponent(filterType),{key:name,tag:"component",class:[
        'filters__field',
        { 'filters__field--double': filterType === 'double' || col === 2 },
        { 'filters__field--spacer': filterType === 'spacer' },
      ],attrs:{"id":`${_vm.type}-${name}`,"value":_vm.activeFilters[name],"name":name,"type":filterType,"label":label,"placeholder":placeholder,"items":items,"options":[
        ...(optionLabel && keyValue ? [{ [optionLabel]: 'Wszystkie', [keyValue]: null }] : []),
        ...(options ? options : []),
      ],"option-label":optionLabel,"key-value":keyValue,"allow-empty":false,"min":min,"max":max,"postfix":postfix,"is-tall":isTall,"separate-labels":""},on:{"emitObject":_vm.onFilterChange}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }